import React, { Component } from 'react';
import { Row, Modal, Form, Select } from 'antd';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.loadOrg();
    this.loadAccount();
  }

  submit = () => {
    const data = this.props.form.getFieldsValue();
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.handSubmit(data);
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="遗失合同"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem {...formItemLayout} label="遗失原因">
              {getFieldDecorator('remark', {
                rules: [{ required: true, message: '遗失原因不能为空！' }],
              })(
                <Select>
                  <Option value="销售保管不善遗失">销售保管不善遗失</Option>
                  <Option value="客户保管不善遗失">客户保管不善遗失</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalLost.js